import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const createEmptyAssignmentState = () => ({
    questions: [],
    rubricQuestions: [],
    currentStep: 0,
    unmatchedValuesPerQuestion: [],
})

const getAssignmentState = (state, token) => {
    if (!state[token]) state[token] = createEmptyAssignmentState()
    return state[token]
}

const initialState = {}

const rubricPersistSlice = createSlice({
    name: 'rubricPersist',
    initialState,
    reducers: {
        mergeQuestions: (state, action) => {
            const { token, questions, rubricQuestions } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.questions = questions.reduce((acc, question) => {
                const matchingRubricQuestion = rubricQuestions.find(
                    rubricQuestion => rubricQuestion.matchingQuestionId == question.id,
                )
                if (matchingRubricQuestion) acc.push({ ...question, rubric: matchingRubricQuestion })
                return acc
            }, [])
        },
        saveQuestion: (state, action) => {
            const { token, id, reviewed } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.questions = assignmentState.questions.map(question =>
                question.id === id ? { ...question, reviewed } : question,
            )
        },
        setQuestions: (state, action) => {
            const { token, questions } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.questions = questions
        },
        setRubricQuestions: (state, action) => {
            const { token, rubricQuestions } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.rubricQuestions = rubricQuestions
        },
        setCurrentStep: (state, action) => {
            const { token, step } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.currentStep = step
        },
        nextStep: (state, action) => {
            const { token } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.currentStep += 1
        },
        previousStep: (state, action) => {
            const { token } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.currentStep -= 1
        },
        setUnmatchedValuesPerQuestion: (state, action) => {
            const { token, unmatchedValuesPerQuestion } = action.payload
            const assignmentState = getAssignmentState(state, token)
            assignmentState.unmatchedValuesPerQuestion = unmatchedValuesPerQuestion
        },
        resetAssignment: (state, action) => {
            const { token } = action.payload
            if (state[token]) {
                state[token] = createEmptyAssignmentState()
            }
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const rubricPersistActions = rubricPersistSlice.actions

export default rubricPersistSlice.reducer
